import { useWorkspaceSales } from '../../hooks/useWorkspaceSales';

const formatCohort = (value) => (value == null ? '—' : `${value}%`);

const ReportsRetention = () => {
  const { data, loading, error } = useWorkspaceSales();
  const retention = data?.reports?.retention;
  const stats = [
    { label: 'Returning clients', value: retention ? `${retention.returningPercent}%` : '0%' },
    { label: 'New clients', value: String(retention?.newClients || 0) },
    { label: 'Avg visits / client', value: String(retention?.avgVisits || 0) },
    { label: 'At risk (60+ days)', value: String(retention?.atRisk || 0) },
  ];

  return (
    <div className="space-y-6">
      <div>
        <h2 className="font-display text-2xl font-light text-ink-900">Client retention</h2>
        <p className="mt-1 text-sm text-ink-700/80">
          How often clients at this location come back after a visit.
        </p>
      </div>

      {error && (
        <div className="border border-red-300 bg-red-50 px-4 py-3 text-sm text-red-800">{error}</div>
      )}

      {loading ? (
        <div className="flex justify-center py-16">
            <div className="h-8 w-8 animate-spin rounded-full border-2 border-ink-900/20 border-t-saffron-500" />
        </div>
      ) : (
        <>
          <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
            {stats.map((item) => (
              <div key={item.label} className="bg-sand-50 px-4 py-4 ring-1 ring-ink-900/10 sm:px-5">
                <p className="text-[11px] font-semibold uppercase tracking-[0.14em] text-ink-600/60">
                  {item.label}
                </p>
                <p className="mt-2 font-display text-3xl font-light text-ink-900">{item.value}</p>
              </div>
            ))}
          </div>

          <div className="bg-sand-50 p-5 ring-1 ring-ink-900/10 sm:p-6">
            <p className="text-xs font-semibold uppercase tracking-[0.14em] text-ink-600/60">
              Rebook cohorts
            </p>
            <ul className="mt-4 space-y-3">
              {(retention?.cohorts || []).map((row) => (
                <li key={row.label} className="flex items-center justify-between gap-4 text-sm">
                  <span className="text-ink-700/80">{row.label}</span>
                  <span className="font-display text-2xl font-light text-ink-900">
                    {formatCohort(row.value)}
                  </span>
                </li>
              ))}
            </ul>
            <p className="mt-4 text-xs text-ink-600/55">
              Cohorts only include clients whose first visit is old enough to measure. A dash means
              there is not enough history yet.
            </p>
          </div>
        </>
      )}
    </div>
  );
};

export default ReportsRetention;
